/**
 * Persist thank-you feedback to `stages.winner`: numeric 1–5, or Arrow Up labels
 * AWESOME | LIKED | MINDBLOWING | LOVED.
 */
export async function updateStageFeedback({ userId, token, stageId, winner }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateStage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      stageId,
      feedbackOnly: true,
      winner,
    }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    const msg = err.message || err.error || `HTTP ${resp.status}`;
    // eslint-disable-next-line no-console
    console.error('[ThankYou feedback] API error', resp.status, msg, err);
    throw new Error(msg);
  }
  return resp.json();
}
